import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const parallaxImages = () => {
  document.fonts.ready.then(() => {
    const holders = document.querySelectorAll('[data-image-parallax]')

    holders.forEach((holder) => {
      const image = holder.querySelectorAll('img, iframe, video')
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: holder,
          start: 'top bottom',
          end: 'center center',
          scrub: true
        }
      })
      tl.fromTo(
        image,
        {
          yPercent: window.innerWidth <= 650 ? -15 : -35,
          scale: window.innerWidth <= 650 ? 1.05 : 1.1
        },
        {
          yPercent: 0,
          scale: 1
        }
      )
    })
  })
}

export default () => {}
